import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';

export const descriptionLookup = {
  store: {
    type: 'array',
    data: [
      {
        id: 'TIME',
        name: i18n2._(
          'Poco tiempo entre creación del curso y vigencia del SOP',
        ),
      },
      {
        id: 'WORKTIME',
        name: i18n2._('Falta de tiempo debido a volumen de trabajo'),
      },
      {id: 'VACATIONS', name: i18n2._('Vacaciones')},
      {id: 'HEALTH', name: i18n2._('Licencia Médica')},
      {id: 'OTHER', name: i18n2._('Otros')},
      {id: 'FORGETTING', name: i18n2._('Olvidé ingresar al sistema')},
    ],
    key: 'id',
  },
};

const ReasonGrid = ({dataSource}) => {
  // const loadCourse = useIntegrityCourse(props.data.key);
  return (
    <IntegrityRoleGrid
      dataSource={dataSource}
      disabledExport={true}
      autoWidth={false}
      id={['value']}
      height={'100%'}
      allowIntegrity={false}
      allowActions={false}
    >
      <Column caption={i18n2._('Descripcion')} dataField="value">
        <Lookup
          dataSource={descriptionLookup}
          valueExpr="id"
          displayExpr="name"
        />
      </Column>
      <Column caption={i18n2._('Porcentaje')} dataField="data" format="#.##" />
    </IntegrityRoleGrid>
  );
};

export default ReasonGrid;
